import { EmptyStateComponent } from 'src/app/Shared/Components/empty-state/empty-state.component';import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { MasterDataService } from 'src/app/Services/master-data.service';
import { ArticleTypeDTO } from 'src/app/DTOs/ArticleTypeDTO';

import { tileRangeLabel } from 'src/app/helper/TileRangeLabel';
import { NotificationService } from 'src/app/Shared/prime-ng/notification.service';
import { DataResult, DataStateChangeEvent, GridDataResult, PageChangeEvent, State, pageSkip, pageTake, process } from 'src/app/Shared/prime-ng/grid-data';
import { PrimeNgModule } from 'src/app/Shared/prime-ng/prime-ng.module';

@Component({
  selector: 'app-article-type-overview',
  standalone: true,
  imports: [PrimeNgModule, CommonModule,
    RouterModule,
    FormsModule,
    EmptyStateComponent
  ],
  templateUrl: './article-type-overview.component.html',
  styleUrl: './article-type-overview.component.css',
  animations: [
    trigger('cardAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class ArticleTypeOverviewComponent implements OnInit, OnDestroy {
  public state: State = {
    skip: 0,
    take: 12,
    sort: [{ field: 'english', dir: 'asc' }]
  };

  public gridView: GridDataResult = { data: [], total: 0 };
  public allRows: ArticleTypeDTO[] = [];
  public loading = false;
  public deleteDialog = false;
  public selectedArticleType: ArticleTypeDTO | null = null;
  public searchText = '';
  public activeActionMenuKey: string | null = null;
  get footerRangeLabel(): string {
    return tileRangeLabel(
      this.gridView.total,
      this.state.take ?? 12,
      this.state.skip ?? 0,
    );
  }

  private destroy$ = new Subject<void>();

  constructor(
    private masterData: MasterDataService,
    private router: Router,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.loadArticleTypes();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadArticleTypes(): void {
    this.loading = true;
    this.masterData.getArticleTypes()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (rows: any) => {
          console.log(rows[0]);
          this.allRows = rows ?? [];
          this.applyFilters();
          this.loading = false;
        },
        error: (err: any) => {
          this.allRows = [];
          this.applyFilters();
          this.loading = false;
          this.notification('Error loading Article Types', 'error');
        }
      });

  }

  public onSearchChange(): void {
    this.state.skip = 0;
    this.applyFilters();
  }

  public clearSearch(): void {
    this.searchText = '';
    this.state.skip = 0;
    this.applyFilters();
  }

  private applyFilters(): void {
    let filtered = [...this.allRows];

    if (this.searchText) {
      const search = this.searchText.toLowerCase();
      filtered = filtered.filter(item =>
        item.english?.toLowerCase().includes(search) ||
        item.german?.toLowerCase().includes(search)
      );
    }

    this.gridView = process(filtered, this.state);
  }

  public pageChange(event: PageChangeEvent): void {
    this.state.skip = pageSkip(event);
    this.state.take = pageTake(event);
    this.applyFilters();
  }
  public toggleActionMenu(key: string | number, event: MouseEvent): void {    event.stopPropagation();    const menuKey = String(key);    this.activeActionMenuKey = this.activeActionMenuKey === menuKey ? null : menuKey;  }  public isActionMenuOpen(key: string | number): boolean {    return this.activeActionMenuKey === String(key);  }  public closeActionMenu(): void {    this.activeActionMenuKey = null;  }
  public createArticleType(): void {
    this.router.navigate(['/article-types/new']);
  }

  public editArticleType(articleType: ArticleTypeDTO): void {
    this.router.navigate(['/article-types', articleType.databaseId]);
  }

  public deleteArticleType(articleType: ArticleTypeDTO): void {
    this.selectedArticleType = articleType;
    this.deleteDialog = true;
  }

  public confirmDelete(): void {
    if (!this.selectedArticleType) return;

    const articleType = this.selectedArticleType;

    this.masterData.deleteArticleType(articleType.databaseId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.allRows = this.allRows.filter(a => a.databaseId !== articleType.databaseId);
          this.applyFilters();
          this.notification(`Article Type "${articleType.english}" deleted`, 'success');
          this.toggleDeleteDialog();
        },
        error: () => {
          this.notification('Error deleting Article Type', 'error');
          this.toggleDeleteDialog();
        }
      });
  }

  public toggleDeleteDialog(): void {
    this.deleteDialog = !this.deleteDialog;
    if (!this.deleteDialog) {
      this.selectedArticleType = null;
    }
  }

  private notification(message: string, state: 'success' | 'error' | 'warning' | 'info'): void {
    this.notificationService.show({
      content: message,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: state, icon: true }
    });
  }

  public onImageError(event: any): void {
    console.error('Bild konnte nicht geladen werden:', event.target.src);
    event.target.style.display = 'none';
  }
}
